import { AnySourceStream, Stream, Subscription } from '../stream'

export class All<V = any, E = any, C = any> extends Stream<V, E, C, V[]> {
    protected sources = new Map<AnySourceStream<V, E, C>, Subscription<V, E, C>>()
    protected latestValues: V[] = []

    constructor(sources: AnySourceStream<V, E, C>[]) {
        super()

        sources.forEach((source, i) => {
            const sub = {
                value: (n) => {
                    this.latestValues[i] = n
                    this._value(this.latestValues.slice())
                },
                error: (err: E) => this._error(err),
                complete: (complete) => {
                    source.unsubscribe(sub)
                    this.sources.delete(source)
                    if (this.sources.size === 0) this._complete(complete)
                },
            } as Subscription<V, E, C>
            this.sources.set(source, sub)
        })
    }

    connect() {
        super.connect()
        for (const [source, sub] of this.sources) source.subscribe(sub)
    }

    disconnect() {
        super.disconnect()
        for (const [source, sub] of this.sources) source.unsubscribe(sub)
    }
}

export const all = <V, E, C>(...sources: AnySourceStream<V, E, C>[]) => {
    return new All(sources)
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        with<DV, DE, DC>(...sources: AnySourceStream<DV, DE, DC>[]): All<DV, DE, DC>
    }
}

Stream.prototype.with = function <V, E, C>(this: AnySourceStream<V, E, C>, ...sources: AnySourceStream<V, E, C>[]) {
    return new All([this, ...sources])
}
